import { useState, useMemo } from "react";

const AREAS = [
  {
    id: "commerciale",
    label: "Commerciale e Strategica",
    icon: "◈",
    color: "#1a6fbf",
    risks: [
      { id: 1, name: "Perdita di quota di mercato", allarme: "Fatturato in calo su base annua, perdita di posizioni nelle gare d'appalto, feedback clienti sul 'prezzo troppo alto'.", azioni: "Analisi dei prezzi dei competitor, piano marketing per riposizionamento, lancio nuovi prodotti/servizi." },
      { id: 2, name: "Inadeguatezza della pianificazione strategica", allarme: "Assenza di un Business Plan aggiornato, decisioni di investimento prese dall'istinto senza valutare il ROI, obiettivi aziendali non chiari.", azioni: "Redazione di un'Analisi SWOT periodica, definizione di KPI misurabili per ogni area aziendale." },
      { id: 3, name: "Dipendenza da cliente principale (concentrazione)", allarme: "Un solo cliente pesa più del 20–30% del fatturato totale.", azioni: "Strategia di diversificazione del portafoglio, ricerca attiva nuovi canali di vendita, assicurazione del credito." },
      { id: 4, name: "Obsolescenza tecnologica del prodotto", allarme: "Calo delle vendite dei prodotti 'storici', i clienti chiedono funzionalità che non abbiamo ma i concorrenti sì.", azioni: "Investimenti in R&D, partnership con startup tecnologiche, restyling del catalogo." },
      { id: 5, name: "Reputazione digitale (Web Reputation)", allarme: "Recensioni negative su Google/Trustpilot, commenti ostili sui social, assenza dai risultati di ricerca.", azioni: "Nomina di un Social Media Manager, campagna di incentivazione recensioni positive, monitoraggio costante del brand online." },
      { id: 6, name: "Ritardo nel lancio nuovi prodotti (Time to Market)", allarme: "Scadenze di progetto costantemente posticipate, competitor che escono prima con prodotti simili.", azioni: "Adozione metodologie Agile/Project Management, semplificazione dei processi approvativi interni." },
    ],
  },
  {
    id: "operativa",
    label: "Operativa e Produzione",
    icon: "⬡",
    color: "#c47b00",
    risks: [
      { id: 7, name: "Dipendenza da fornitore unico", allarme: "Impossibilità di produrre se manca un componente fornito da una sola azienda, tempi di consegna che si allungano.", azioni: "Scouting di fornitori alternativi (second source), aumento delle scorte di sicurezza dei componenti critici." },
      { id: 8, name: "Fluttuazione prezzi materie prime", allarme: "Erosione del margine di guadagno, listini fornitori che cambiano mensilmente.", azioni: "Contratti quadro a prezzo bloccato, clausole di revisione prezzi nei contratti di vendita, acquisti speculativi anticipati." },
      { id: 9, name: "Interruzione supply chain (logistica)", allarme: "Ritardi cronici nelle consegne ai clienti, merce ferma in dogana, costi di trasporto in aumento.", azioni: "Diversificazione dei partner logistici, avvicinamento della filiera (reshoring), ottimizzazione del magazzino." },
      { id: 10, name: "Fermo impianti o macchinari", allarme: "Frequenti guasti imprevisti, macchinari obsoleti senza pezzi di ricambio reperibili, assenza di piano manutenzione.", azioni: "Piano di manutenzione preventiva/predittiva, acquisto ricambi critici, contratti di assistenza rapida." },
      { id: 11, name: "Difettosità materie in ingresso", allarme: "Aumento degli scarti di produzione, lotti di merce respinti in accettazione.", azioni: "Audit presso i fornitori, inasprimento dei controlli qualità in ingresso, revisione capitolati tecnici." },
    ],
  },
  {
    id: "finanziaria",
    label: "Finanziaria e Amministrativa",
    icon: "▲",
    color: "#2a9d4e",
    risks: [
      { id: 12, name: "Liquidità (Cash Flow)", allarme: "Difficoltà a pagare stipendi o F24 puntualmente, utilizzo costante dei fidi bancari al limite massimo, CCN negativo.", azioni: "Pianificazione finanziaria precisa, budget di tesoreria a 6 mesi, ristrutturazione del debito, factoring." },
      { id: 13, name: "Inadeguatezza della pianificazione finanziaria", allarme: "Decisioni di investimento prese sull'istinto senza valutare l'impatto reale sulla cassa, squilibrio fonti/impieghi.", azioni: "Implementazione di una pianificazione finanziaria strutturata a 3–5 anni, redazione periodica del rendiconto finanziario." },
      { id: 14, name: "Crediti in sofferenza", allarme: "Aumento del DSO (giorni medi incasso), clienti storici che iniziano a ritardare i pagamenti.", azioni: "Report mensile scadenziario, blocco ordini automatico per insoluti, assicurazione del credito, recupero crediti esterno." },
      { id: 15, name: "Revoca affidamenti bancari", allarme: "Rating bancario in peggioramento, centrale rischi con segnalazioni, comunicazioni della banca per rientro fidi.", azioni: "Diversificazione degli istituti di credito, miglioramento degli indici di bilancio, comunicazione trasparente con la banca." },
      { id: 16, name: "Tasso di interesse", allarme: "Aumento degli oneri finanziari a bilancio, presenza di molti mutui a tasso variabile.", azioni: "Rinegoziazione mutui, passaggio a tasso fisso, utilizzo di strumenti derivati di copertura (CAP/Swap) con cautela." },
      { id: 17, name: "Cambio valuta", allarme: "Margini erosi su commesse estere a causa della svalutazione/rivalutazione della moneta.", azioni: "Contratti in Euro dove possibile, strumenti di copertura rischio cambio (forward), conti in valuta estera." },
      { id: 18, name: "Errori contabili o di bilancio", allarme: "Sanzioni dall'Agenzia delle Entrate, rettifiche frequenti, bilanci non riconciliati.", azioni: "Audit esterno volontario, formazione continua ufficio amministrativo, software di controllo gestione." },
    ],
  },
  {
    id: "legale",
    label: "Legale e Compliance",
    icon: "⬟",
    color: "#7b3fa0",
    risks: [
      { id: 19, name: "Reati (D.Lgs 231/01)", allarme: "Assenza del Modello Organizzativo 231, processi decisionali non tracciati, uso di contanti elevato o ingiustificato.", azioni: "Adozione Modello 231 e nomina OdV (Organismo di Vigilanza), codice etico diffuso." },
      { id: 20, name: "Contenziosi con clienti/fornitori", allarme: "Numero elevato di cause legali in corso, contratti non firmati o accettati solo via email/bolla.", azioni: "Revisione della contrattualistica standard da studio legale, clausole di mediazione/arbitrato." },
      { id: 21, name: "Accertamenti fiscali", allarme: "Discrepanze negli studi di settore (ISA), operazioni straordinarie complesse senza parere legale.", azioni: "Tax control framework, pareri pro-veritate su operazioni complesse, verifica periodica col commercialista." },
      { id: 22, name: "Proprietà intellettuale", allarme: "Prodotti copiati dai concorrenti, utilizzo di marchi non registrati, software senza licenze in azienda.", azioni: "Registrazione marchi e brevetti, accordi di riservatezza (NDA) con dipendenti e fornitori, audit licenze software." },
      { id: 23, name: "Violazione privacy (GDPR)", allarme: "Invio newsletter senza consenso, gestione dati sensibili su file Excel non protetti, mancata nomina DPO se necessario.", azioni: "Aggiornamento registro trattamenti, formazione privacy dipendenti, nomina responsabili esterni." },
    ],
  },
  {
    id: "hr",
    label: "Risorse Umane e Organizzazione",
    icon: "◉",
    color: "#c0392b",
    risks: [
      { id: 24, name: "Infortuni sul lavoro (sicurezza)", allarme: "Aumento numero infortuni o near miss, DVR non aggiornato, mancata formazione obbligatoria.", azioni: "Aggiornamento rigoroso del DVR ex D.Lgs 81/08, audit di sicurezza sul campo, investimenti in DPI, nomina RSPP/RLS/Preposti." },
      { id: 25, name: "Turnover elevato", allarme: "Dimissioni frequenti di personale neo-assunto o storico, difficoltà a trovare sostituti.", azioni: "Analisi clima aziendale, piano di welfare, revisione politica retributiva e bonus." },
      { id: 26, name: "Perdita uomo chiave (Key Man)", allarme: "Processi critici che sa fare solo una persona, assenza di deleghe, accentramento decisionale.", azioni: "Piano di successione, affiancamento junior-senior, mappatura e trascrizione delle procedure operative." },
      { id: 27, name: "Infedeltà aziendale o frodi interne", allarme: "Ammanchi di cassa o magazzino, dipendenti che lavorano per la concorrenza, furto di database clienti.", azioni: "Patto di non concorrenza, segregazione delle funzioni (chi ordina non paga), controlli a campione." },
      { id: 28, name: "Competenze obsolete", allarme: "Personale che non sa usare i nuovi software, errori operativi ricorrenti, lentezza nell'adattarsi.", azioni: "Piano di formazione continua (fondi interprofessionali), job rotation." },
      { id: 29, name: "Clima sindacale e scioperi", allarme: "Aumento delle vertenze sindacali, micro-conflittualità diffusa, assenteismo strategico.", azioni: "Tavoli di confronto periodici con RSU, trasparenza nelle comunicazioni aziendali." },
    ],
  },
  {
    id: "it",
    label: "IT e Cyber Security",
    icon: "⬢",
    color: "#16788a",
    risks: [
      { id: 30, name: "Attacco ransomware (blocco dati)", allarme: "Sistemi non aggiornati (patching), antivirus scaduti, dipendenti che aprono allegati sospetti.", azioni: "Backup in cloud scollegato dalla rete, autenticazione a due fattori (MFA) ovunque, simulazioni di phishing, assicurazione Cyber Risk." },
      { id: 31, name: "Perdita dati (no backup)", allarme: "Backup fatto solo su disco locale, mai testato il ripristino (restore).", azioni: "Test di ripristino semestrale, regola del backup 3-2-1 (3 copie, 2 supporti diversi, 1 off-site)." },
      { id: 32, name: "Fermo sistema gestionale (ERP)", allarme: "Server vecchio e senza garanzia, software non più supportato dalla casa madre.", azioni: "Migrazione in Cloud/SaaS, contratto di assistenza con SLA garantiti, hardware in alta affidabilità." },
      { id: 33, name: "Accessi non autorizzati (logici)", allarme: "Password condivise su post-it, ex dipendenti con account ancora attivi.", azioni: "Policy password complesse con scadenza, disattivazione immediata utenze dimissionari." },
    ],
  },
  {
    id: "ambiente",
    label: "Ambiente e Qualità",
    icon: "◆",
    color: "#2d7a3a",
    risks: [
      { id: 34, name: "Gestione rifiuti", allarme: "Registri di carico/scarico non aggiornati, stoccaggio rifiuti disordinato o senza etichette, codici CER errati.", azioni: "Audit ambientale, incarico a consulente esperto per MUD, formazione addetti magazzino." },
      { id: 35, name: "Sversamenti o inquinamento", allarme: "Vasche di contenimento assenti o danneggiate, presenza di liquidi pericolosi vicino a tombini.", azioni: "Kit antisversamento nei reparti, impermeabilizzazione pavimentazioni, verifica tenuta cisterne." },
      { id: 36, name: "Conformità di prodotto (qualità)", allarme: "Percentuale alta di resi da cliente, non conformità rilevate in fase di collaudo finale.", azioni: "Certificazione ISO 9001, taratura strumenti di misura, circoli della qualità." },
      { id: 37, name: "Richiamo prodotti dal mercato", allarme: "Segnalazioni di pericolosità del prodotto venduto, difetti seriali scoperti post-vendita.", azioni: "Sistema di tracciabilità del lotto impeccabile, assicurazione Product Liability." },
    ],
  },
  {
    id: "infrastrutture",
    label: "Infrastrutture e Sicurezza Fisica",
    icon: "⬛",
    color: "#5a5a5a",
    risks: [
      { id: 38, name: "Incendio", allarme: "Carico d'incendio elevato, estintori non revisionati, vie di fuga ingombre.", azioni: "Ottenimento CPI, prove di evacuazione annuali, impianto rilevazione fumi, assicurazione antincendio." },
      { id: 39, name: "Intrusione e furto (ladri)", allarme: "Assenza di allarme o telecamere, recinzioni basse, accessi non controllati negli orari di lavoro.", azioni: "Vigilanza notturna, sistema TVCC, controllo accessi con badge, assicurazione antifurto." },
      { id: 40, name: "Interruzione fornitura energia", allarme: "Frequenti sbalzi di tensione, zona industriale soggetta a blackout.", azioni: "Installazione gruppi di continuità (UPS), gruppo elettrogeno diesel, impianto fotovoltaico con accumulo." },
      { id: 41, name: "Catastrofi naturali (sismico/idrogeologico)", allarme: "Sede in zona sismica o alluvionale, capannone non antisismico.", azioni: "Assicurazione specifica catastrofale, adeguamento strutturale immobile, piano di emergenza." },
      { id: 42, name: "Danni al parco veicoli", allarme: "Alta frequenza di sinistri stradali dei dipendenti/agenti, manutenzione veicoli scarsa.", azioni: "Policy auto aziendale, corsi di guida sicura, monitoraggio satellitare flotte." },
      { id: 43, name: "Sabotaggio", allarme: "Rapporti conflittuali con dipendenti licenziati, accessi ai server non monitorati.", azioni: "Revoca immediata accessi fisici e logici, telecamere nei punti nevralgici (server room, magazzino)." },
      { id: 44, name: "Pandemico / sanitario", allarme: "Assenza di protocolli igienici, spazi di lavoro sovraffollati.", azioni: "Piano di smart working pronto all'uso, scorte di DPI, sanificazione periodica impianti aerazione." },
    ],
  },
];

const PROB_LABELS = ["", "Improbabile", "Poco probabile", "Probabile", "Altamente probabile"];
const GRAV_LABELS = ["", "Lieve", "Medio", "Grave", "Gravissimo"];

function getRiskScore(p, g) { return p && g ? p * g : null; }

function getRiskLevel(score) {
  if (score === null) return null;
  if (score <= 2) return { label: "Basso", bg: "#d4edda", text: "#1a5e2a", border: "#2a9d4e" };
  if (score <= 4) return { label: "Basso-Medio", bg: "#d4edda", text: "#1a5e2a", border: "#2a9d4e" };
  if (score <= 6) return { label: "Medio", bg: "#fff3cd", text: "#7a4f00", border: "#e8a000" };
  if (score <= 8) return { label: "Medio-Alto", bg: "#fde8c8", text: "#8a3500", border: "#e86000" };
  if (score <= 12) return { label: "Alto", bg: "#fddcc8", text: "#8a2000", border: "#e84000" };
  return { label: "Critico", bg: "#f8d7da", text: "#721c24", border: "#c0392b" };
}

function MatrixCell({ p, g, highlighted }) {
  const score = p * g;
  const level = getRiskLevel(score);
  const isHl = highlighted && highlighted.p === p && highlighted.g === g;
  return (
    <div style={{
      width: 44, height: 44,
      background: level.bg,
      border: isHl ? `3px solid #111` : `1px solid ${level.border}`,
      borderRadius: 4,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "'JetBrains Mono', monospace",
      fontSize: 13, fontWeight: 700,
      color: level.text,
      boxShadow: isHl ? "0 0 0 2px #111" : "none",
      transition: "all 0.15s",
    }}>{score}</div>
  );
}

function ScoreSelector({ label, value, onChange, options, descriptions }) {
  return (
    <div style={{ flex: 1 }}>
      <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.08em", color: "#666", marginBottom: 6, textTransform: "uppercase" }}>{label}</div>
      <div style={{ display: "flex", gap: 4 }}>
        {[1,2,3,4].map(v => (
          <button
            key={v}
            onClick={() => onChange(value === v ? null : v)}
            title={descriptions[v]}
            style={{
              flex: 1, height: 36, border: "none", borderRadius: 4, cursor: "pointer",
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: 13, fontWeight: 700,
              background: value === v
                ? (label === "PROBABILITÀ"
                  ? ["","#b8e0ff","#7dc5f5","#3592d4","#0a5c99"][v]
                  : ["","#d4f5b0","#f5d87a","#f59e4a","#e84040"][v])
                : "#f0f0f0",
              color: value === v ? "#fff" : "#999",
              transition: "all 0.15s",
              boxShadow: value === v ? "0 2px 6px rgba(0,0,0,0.2)" : "none",
            }}
          >{v}</button>
        ))}
      </div>
      {value && (
        <div style={{ fontSize: 10, color: "#888", marginTop: 3, fontStyle: "italic" }}>
          {descriptions[value]}
        </div>
      )}
    </div>
  );
}

function RiskCard({ risk, values, onChange, areaColor }) {
  const prob = values?.prob ?? null;
  const grav = values?.grav ?? null;
  const score = getRiskScore(prob, grav);
  const level = getRiskLevel(score);
  const isComplete = prob !== null && grav !== null;

  return (
    <div style={{
      border: `1px solid ${isComplete ? (level?.border || "#ddd") : "#e0e0e0"}`,
      borderLeft: `4px solid ${areaColor}`,
      borderRadius: 8,
      padding: "16px 18px",
      background: isComplete ? level.bg + "55" : "#fafafa",
      marginBottom: 10,
      transition: "all 0.2s",
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10, gap: 12 }}>
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
            <span style={{ fontSize: 11, fontWeight: 700, color: areaColor, fontFamily: "'JetBrains Mono', monospace" }}>#{risk.id}</span>
            <span style={{ fontSize: 13, fontWeight: 700, color: "#1a1a1a" }}>{risk.name}</span>
          </div>
        </div>
        {isComplete && (
          <div style={{
            minWidth: 80, textAlign: "center", padding: "4px 10px",
            background: level.bg, border: `1px solid ${level.border}`,
            borderRadius: 20, flexShrink: 0,
          }}>
            <div style={{ fontSize: 18, fontWeight: 900, color: level.text, fontFamily: "'JetBrains Mono', monospace", lineHeight: 1 }}>{score}</div>
            <div style={{ fontSize: 9, fontWeight: 700, color: level.text, textTransform: "uppercase", letterSpacing: "0.06em" }}>{level.label}</div>
          </div>
        )}
      </div>

      <details style={{ marginBottom: 12 }}>
        <summary style={{ fontSize: 11, color: "#888", cursor: "pointer", userSelect: "none", fontWeight: 600 }}>
          ▸ Indicatori di allarme e azioni migliorative
        </summary>
        <div style={{ marginTop: 8, padding: "10px 12px", background: "#fff", borderRadius: 6, border: "1px solid #eee" }}>
          <div style={{ fontSize: 11, color: "#c05000", marginBottom: 6 }}>
            <strong>⚠ Indicatori:</strong> {risk.allarme}
          </div>
          <div style={{ fontSize: 11, color: "#1a5e2a" }}>
            <strong>✓ Azioni migliorative:</strong> {risk.azioni}
          </div>
        </div>
      </details>

      <div style={{ display: "flex", gap: 12 }}>
        <ScoreSelector
          label="Probabilità"
          value={prob}
          onChange={v => onChange({ prob: v, grav })}
          descriptions={PROB_LABELS}
        />
        <ScoreSelector
          label="Gravità (Impatto)"
          value={grav}
          onChange={v => onChange({ prob, grav: v })}
          descriptions={GRAV_LABELS}
        />
      </div>
    </div>
  );
}

function Dashboard({ allRisks, values }) {
  const scored = allRisks.filter(r => {
    const v = values[r.id];
    return v?.prob && v?.grav;
  });

  const byLevel = { Critico: [], Alto: [], "Medio-Alto": [], Medio: [], "Basso-Medio": [], Basso: [] };
  scored.forEach(r => {
    const v = values[r.id];
    const score = v.prob * v.grav;
    const l = getRiskLevel(score);
    if (byLevel[l.label]) byLevel[l.label].push({ ...r, score, level: l });
  });

  const top5 = scored
    .map(r => ({ ...r, score: values[r.id].prob * values[r.id].grav, level: getRiskLevel(values[r.id].prob * values[r.id].grav) }))
    .sort((a, b) => b.score - a.score)
    .slice(0, 5);

  const completion = Math.round((scored.length / allRisks.length) * 100);

  return (
    <div style={{ padding: "0 0 24px" }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12, marginBottom: 24 }}>
        {[
          { label: "Rischi valutati", value: `${scored.length}/${allRisks.length}`, sub: `${completion}% completato`, color: "#1a6fbf" },
          { label: "Rischi critici / alti", value: (byLevel["Critico"].length + byLevel["Alto"].length), sub: "richiedono azione urgente", color: "#c0392b" },
          { label: "Score medio", value: scored.length ? (scored.reduce((s, r) => s + values[r.id].prob * values[r.id].grav, 0) / scored.length).toFixed(1) : "–", sub: "su scala 1–16", color: "#7b3fa0" },
        ].map(c => (
          <div key={c.label} style={{ background: "#fff", border: "1px solid #e8e8e8", borderRadius: 10, padding: "16px 20px", borderTop: `4px solid ${c.color}` }}>
            <div style={{ fontSize: 11, color: "#888", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>{c.label}</div>
            <div style={{ fontSize: 28, fontWeight: 900, color: c.color, fontFamily: "'JetBrains Mono', monospace", lineHeight: 1 }}>{c.value}</div>
            <div style={{ fontSize: 11, color: "#aaa", marginTop: 4 }}>{c.sub}</div>
          </div>
        ))}
      </div>

      {top5.length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: "#1a1a1a", marginBottom: 12, textTransform: "uppercase", letterSpacing: "0.08em" }}>
            Top 5 Rischi per Score
          </div>
          {top5.map((r, i) => (
            <div key={r.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", background: r.level.bg, border: `1px solid ${r.level.border}`, borderRadius: 8, marginBottom: 6 }}>
              <div style={{ fontSize: 14, fontWeight: 900, color: r.level.text, fontFamily: "'JetBrains Mono', monospace", minWidth: 20 }}>#{i+1}</div>
              <div style={{ flex: 1, fontSize: 12, fontWeight: 600, color: "#1a1a1a" }}>{r.name}</div>
              <div style={{ fontSize: 18, fontWeight: 900, color: r.level.text, fontFamily: "'JetBrains Mono', monospace" }}>{r.score}</div>
              <div style={{ fontSize: 10, fontWeight: 700, color: r.level.text, textTransform: "uppercase", minWidth: 70, textAlign: "right" }}>{r.level.label}</div>
            </div>
          ))}
        </div>
      )}

      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 13, fontWeight: 800, color: "#1a1a1a", marginBottom: 12, textTransform: "uppercase", letterSpacing: "0.08em" }}>
          Matrice del Rischio
        </div>
        <div style={{ background: "#fff", border: "1px solid #e8e8e8", borderRadius: 10, padding: "20px 24px", display: "inline-block" }}>
          <div style={{ display: "flex", gap: 4, marginBottom: 4, paddingLeft: 60 }}>
            {[1,2,3,4].map(g => (
              <div key={g} style={{ width: 44, textAlign: "center", fontSize: 10, fontWeight: 700, color: "#888" }}>{GRAV_LABELS[g].substring(0,5)}</div>
            ))}
          </div>
          {[4,3,2,1].map(p => (
            <div key={p} style={{ display: "flex", gap: 4, marginBottom: 4, alignItems: "center" }}>
              <div style={{ width: 56, fontSize: 10, fontWeight: 700, color: "#888", textAlign: "right", paddingRight: 4 }}>{PROB_LABELS[p].substring(0,6)}.</div>
              {[1,2,3,4].map(g => <MatrixCell key={g} p={p} g={g} highlighted={null} />)}
            </div>
          ))}
          <div style={{ paddingLeft: 60, marginTop: 4 }}>
            <div style={{ fontSize: 9, color: "#aaa", textAlign: "center" }}>← Gravità →</div>
          </div>
          <div style={{ display: "flex", gap: 8, marginTop: 12, flexWrap: "wrap" }}>
            {[{s:"≤4", l:"Basso", c:"#2a9d4e"},{s:"5–6", l:"Medio", c:"#e8a000"},{s:"7–9", l:"Alto", c:"#e84000"},{s:"10–16", l:"Critico", c:"#c0392b"}].map(x => (
              <div key={x.l} style={{ display: "flex", alignItems: "center", gap: 5 }}>
                <div style={{ width: 12, height: 12, borderRadius: 2, background: x.c, opacity: 0.7 }} />
                <span style={{ fontSize: 10, color: "#666", fontWeight: 600 }}>{x.l} ({x.s})</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {Object.entries(byLevel).filter(([, risks]) => risks.length > 0).map(([level, risks]) => {
        const sample = getRiskLevel(risks[0].score);
        return (
          <div key={level} style={{ marginBottom: 16 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
              <div style={{ width: 10, height: 10, borderRadius: "50%", background: sample.border }} />
              <div style={{ fontSize: 12, fontWeight: 800, color: sample.text, textTransform: "uppercase", letterSpacing: "0.06em" }}>
                {level} ({risks.length})
              </div>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {risks.map(r => (
                <div key={r.id} style={{ padding: "4px 10px", background: sample.bg, border: `1px solid ${sample.border}`, borderRadius: 20, fontSize: 11, color: sample.text, fontWeight: 600 }}>
                  #{r.id} {r.name}
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function App() {
  const [view, setView] = useState("questionnaire"); // "questionnaire" | "dashboard"
  const [activeArea, setActiveArea] = useState(AREAS[0].id);
  const [values, setValues] = useState({});
  const [company, setCompany] = useState("");

  const allRisks = useMemo(() => AREAS.flatMap(a => a.risks.map(r => ({ ...r, areaId: a.id, areaLabel: a.label, areaColor: a.color }))), []);

  const area = AREAS.find(a => a.id === activeArea);

  const areaProgress = (a) => {
    const total = a.risks.length;
    const done = a.risks.filter(r => values[r.id]?.prob && values[r.id]?.grav).length;
    return { done, total, pct: Math.round((done / total) * 100) };
  };

  const totalDone = allRisks.filter(r => values[r.id]?.prob && values[r.id]?.grav).length;

  return (
    <div style={{ minHeight: "100vh", background: "#f4f4f2", fontFamily: "'Segoe UI', sans-serif" }}>
      {/* Header */}
      <div style={{ background: "#111", color: "#fff", padding: "0 24px" }}>
        <div style={{ maxWidth: 960, margin: "0 auto" }}>
          <div style={{ padding: "16px 0 12px", borderBottom: "1px solid #2a2a2a" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
              <div>
                <div style={{ fontSize: 10, letterSpacing: "0.2em", color: "#888", textTransform: "uppercase", marginBottom: 2 }}>ISO 31000 · ISO 31010 · D.Lgs 14/2019</div>
                <div style={{ fontSize: 20, fontWeight: 900, letterSpacing: "-0.02em" }}>
                  Risk Assessment <span style={{ color: "#e85c1e" }}>·</span> Valutazione Rischi Aziendali
                </div>
              </div>
              <input
                placeholder="Nome azienda…"
                value={company}
                onChange={e => setCompany(e.target.value)}
                style={{ background: "#222", border: "1px solid #333", color: "#fff", padding: "8px 14px", borderRadius: 6, fontSize: 13, width: 200, outline: "none" }}
              />
            </div>
          </div>
          <div style={{ display: "flex", gap: 2, padding: "8px 0" }}>
            {[
              { id: "questionnaire", label: `Questionario (${totalDone}/${allRisks.length})` },
              { id: "dashboard", label: "Dashboard & Sintesi" },
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setView(tab.id)}
                style={{
                  background: view === tab.id ? "#e85c1e" : "transparent",
                  color: view === tab.id ? "#fff" : "#888",
                  border: "none", borderRadius: 6, padding: "7px 16px",
                  fontSize: 12, fontWeight: 700, cursor: "pointer",
                  textTransform: "uppercase", letterSpacing: "0.06em",
                  transition: "all 0.15s",
                }}
              >{tab.label}</button>
            ))}
          </div>
        </div>
      </div>

      <div style={{ maxWidth: 960, margin: "0 auto", padding: "20px 24px" }}>
        {view === "dashboard" ? (
          <Dashboard allRisks={allRisks} values={values} />
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "220px 1fr", gap: 20, alignItems: "start" }}>
            {/* Sidebar */}
            <div style={{ position: "sticky", top: 20 }}>
              <div style={{ background: "#fff", borderRadius: 10, border: "1px solid #e8e8e8", overflow: "hidden" }}>
                <div style={{ background: "#111", color: "#fff", padding: "10px 14px", fontSize: 10, fontWeight: 800, letterSpacing: "0.12em", textTransform: "uppercase" }}>
                  Aree di Rischio
                </div>
                {AREAS.map(a => {
                  const { done, total, pct } = areaProgress(a);
                  const isActive = a.id === activeArea;
                  return (
                    <button
                      key={a.id}
                      onClick={() => setActiveArea(a.id)}
                      style={{
                        width: "100%", textAlign: "left", padding: "10px 14px",
                        background: isActive ? a.color + "18" : "transparent",
                        border: "none", borderBottom: "1px solid #f0f0f0",
                        cursor: "pointer", transition: "all 0.15s",
                        borderLeft: isActive ? `3px solid ${a.color}` : "3px solid transparent",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
                        <span style={{ color: a.color, fontSize: 12 }}>{a.icon}</span>
                        <span style={{ fontSize: 11, fontWeight: 700, color: isActive ? a.color : "#333", lineHeight: 1.3 }}>{a.label}</span>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <div style={{ flex: 1, height: 3, background: "#f0f0f0", borderRadius: 2 }}>
                          <div style={{ width: `${pct}%`, height: "100%", background: a.color, borderRadius: 2, transition: "width 0.3s" }} />
                        </div>
                        <span style={{ fontSize: 9, color: "#aaa", minWidth: 28, textAlign: "right" }}>{done}/{total}</span>
                      </div>
                    </button>
                  );
                })}
              </div>
              <div style={{ marginTop: 12, background: "#fff", border: "1px solid #e8e8e8", borderRadius: 10, padding: "12px 14px" }}>
                <div style={{ fontSize: 10, fontWeight: 800, color: "#888", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>Legenda score</div>
                {[
                  {range:"1–4", label:"Basso", color:"#2a9d4e"},
                  {range:"5–6", label:"Medio", color:"#e8a000"},
                  {range:"7–9", label:"Alto", color:"#e86000"},
                  {range:"10–16", label:"Critico", color:"#c0392b"},
                ].map(l => (
                  <div key={l.label} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 5 }}>
                    <div style={{ width: 24, height: 24, borderRadius: 4, background: l.color + "22", border: `1px solid ${l.color}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <span style={{ fontSize: 8, fontWeight: 800, color: l.color }}>{l.range}</span>
                    </div>
                    <span style={{ fontSize: 11, color: "#555", fontWeight: 600 }}>{l.label}</span>
                  </div>
                ))}
                <div style={{ marginTop: 10, fontSize: 10, color: "#aaa", lineHeight: 1.4 }}>
                  Score = Probabilità × Gravità<br/>
                  <span style={{ color: "#c05000" }}>P</span> e <span style={{ color: "#1a5e2a" }}>G</span> su scala 1–4
                </div>
              </div>
            </div>

            {/* Main content */}
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
                <span style={{ fontSize: 22, color: area.color }}>{area.icon}</span>
                <div>
                  <div style={{ fontSize: 16, fontWeight: 900, color: "#111", letterSpacing: "-0.01em" }}>{area.label}</div>
                  <div style={{ fontSize: 11, color: "#888" }}>{area.risks.length} rischi in questa area</div>
                </div>
              </div>
              {area.risks.map(risk => (
                <RiskCard
                  key={risk.id}
                  risk={risk}
                  values={values[risk.id] || {}}
                  onChange={v => setValues(prev => ({ ...prev, [risk.id]: v }))}
                  areaColor={area.color}
                />
              ))}
              {activeArea !== AREAS[AREAS.length - 1].id && (
                <button
                  onClick={() => {
                    const idx = AREAS.findIndex(a => a.id === activeArea);
                    setActiveArea(AREAS[idx + 1].id);
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  style={{
                    marginTop: 8, width: "100%", padding: "12px",
                    background: area.color, color: "#fff", border: "none",
                    borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer",
                    letterSpacing: "0.04em",
                  }}
                >
                  Prossima area → {AREAS[AREAS.findIndex(a => a.id === activeArea) + 1]?.label}
                </button>
              )}
              {activeArea === AREAS[AREAS.length - 1].id && (
                <button
                  onClick={() => setView("dashboard")}
                  style={{
                    marginTop: 8, width: "100%", padding: "12px",
                    background: "#e85c1e", color: "#fff", border: "none",
                    borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer",
                    letterSpacing: "0.04em",
                  }}
                >
                  Visualizza Dashboard & Sintesi →
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
